import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { DownloadAttachmentIcon } from 'shared/assets/svg/menu-icons/DownloadAttachmentIcon';
import { ExpandAttachmentIcon } from 'shared/assets/svg/menu-icons/ExpandAttachmentIcon';
import { Dialog, DialogContent, DialogTrigger } from 'shared/components/ui/dialog';
import { ScrollArea, ScrollBar } from 'shared/components/ui/scroll-area';
import styles from './TxtFileArtifact.module.scss';
import colorsStore from 'shared/store/colorsStore';
import { useFileOperations } from '@dev-streetbeat/chat/react';

import type { File } from '@dev-streetbeat/chat/types';

type Props = {
  file: File;
  onFinishLoading?: () => void;
};

export const TxtFileArtifact: React.FC<Props> = ({ file, onFinishLoading }) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);

  const params = useParams();
  const threadId = params.threadId;
  const [content, setContent] = useState<string>();

  const { downloadFile } = useFileOperations();

  useEffect(() => {
    if (threadId) {
      downloadFile(file.id)
        .then(async (response) => {
          const c = await response.text();
          setContent(c);
        })
        .finally(() => {
          onFinishLoading?.();
        });
    }
  }, [threadId]);

  const download = async () => {
    const fileName = file.name;
    const fileId = file.id;
    if (threadId) {
      const response = await downloadFile(fileId);

      const link = document.createElement('a');
      link.href = URL.createObjectURL(response);
      link.download = fileName;
      link.click();
    }
  };

  return (
    <>
      <div className={styles.txtContainer}>
        <div className={styles.txtActions}>
          <div className={styles.downloadButton} onClick={download}>
            <DownloadAttachmentIcon />
          </div>
          <Dialog>
            <DialogTrigger asChild>
              <ExpandAttachmentIcon className={styles.expandButton} />
            </DialogTrigger>
            <DialogContent
              className={styles.dialogContent}
              style={{
                backgroundColor: colorsConfig.finecoBlueLight,
                color: colorsConfig.finecoBlack,
              }}
              xColor={colorsConfig.finecoBlack}
            >
              <ScrollArea className="max-h-screen py-4 pb-12">
                <p className="p-4">{content}</p>
                <ScrollBar orientation="horizontal" />
              </ScrollArea>
            </DialogContent>
          </Dialog>
        </div>
      </div>
      <div id={file.id.toString()} className="txt-attachment-scroll-margin" />
    </>
  );
};
